import { FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { Variant } from '@mui/material/styles/createTypography'

function CardGroupHeader({
  pretitleId,
  titleId,
  titleVariant = 'h5'
}: {
  pretitleId?: string
  titleId: string
  titleVariant?: Variant
}) {
  return (
    <Box mb={3} display="flex" flexDirection="column" gap={1}>
      {pretitleId && (
        <Typography variant="overline">
          <FormattedMessage id={pretitleId} />
        </Typography>
      )}
      <Typography variant={titleVariant}>
        <FormattedMessage id={titleId} />
      </Typography>
    </Box>
  )
}
export default CardGroupHeader
